import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
import { Broadcast } from '../../types/api';

interface fetchBroadcastsProps {
    filters: any;
    enabled?: boolean;
    query: {
        page: number;
        pageSize: number;
    };
}

const fetchBroadcasts = async ({
    filters,
    query,
}: fetchBroadcastsProps): Promise<Broadcast[]> => {
    const response = await sportsApi
        .url('/media-uploads/broadcasts')
        .json({
            action: 'fetchQuery',
            domainObject: {
                ...query,
                ...filters,
            },
        })
        .post()
        .json();

    return response as unknown as Broadcast[];
};

const useBroadcasts = ({
    filters,
    query,
    enabled = true,
}: fetchBroadcastsProps) => {
    return useQuery(
        ['MediaUploadKey-broadcasts', query, filters],
        () => fetchBroadcasts({ filters, query }),
        { enabled },
    );
};

export default useBroadcasts;
